import { AxiosError } from "axios";
import TextInput from "../../../../components/TextInput";
import { useToast } from "../../../../hooks/useToast";
import { login } from "../../../../api";
import { FormEvent, PropsWithChildren, useState } from "react";
import { createDeviceId } from "../../../../utils/device";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../../../hooks/useSession";
import Button from "../../../../components/Button";

interface Props {
  isLoading: boolean;
  setLoading: (isLoading: boolean) => void;
}

export default function Login(props: PropsWithChildren<Props>) {
  const { isLoading, setLoading, children } = props;
  const { toast } = useToast();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const { fetchProfile } = useSession();
  const navigate = useNavigate();

  const signIn = async (event?: FormEvent) => {
    event?.preventDefault();
    const form = event?.currentTarget as HTMLFormElement | undefined;
    const formData = form ? new FormData(form) : undefined;
    const nextEmail = email || String(formData?.get("email") ?? "").trim();
    const nextPassword = password || String(formData?.get("password") ?? "");
    try {
      setLoading(true);
      const deviceId =
        localStorage.getItem("deviceId") ?? (await createDeviceId());
      await login(nextEmail, nextPassword, deviceId);
      localStorage.setItem("deviceId", deviceId);
      await fetchProfile();
      navigate("/home");
      toast({
        message: "Login efetuado com sucesso",
        type: "success",
      });
    } catch (error) {
      let errorMessage = "Não foi possível entrar. Verifique o e-mail e a senha.";
      if (error instanceof AxiosError) {
        const serverError = error.response?.data;
        if (serverError && serverError.error && serverError.message) {
          errorMessage = serverError.message;
        }
      }
      toast({
        message: errorMessage,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="flex flex-col gap-4" onSubmit={signIn}>
      <TextInput
        id="email"
        name="email"
        type="email"
        autoComplete="email"
        spellCheck={false}
        variant="outlined"
        label="E-mail"
        placeholder="nome@instituicao.edu.br…"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <TextInput
        id="password"
        name="password"
        type="password"
        autoComplete="current-password"
        variant="outlined"
        label="Senha"
        placeholder="Sua senha…"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      <Button type="submit" disabled={isLoading}>
        {isLoading ? "Entrando…" : "Entrar"}
      </Button>

      {children}
    </form>
  );
}
